export const overlayInstanceIds = {
  MENU: 'MENU',
  INTERSTITIAL_CONTENT: 'INTERSTITIAL_CONTENT',
  DONATION_CONTENT: 'DONATION_CONTENT',
  MAP_STATIONS: 'MAP_STATIONS',
  MAP_TOOLTIP: 'MAP_TOOLTIP',
  BASE_TOOLTIP: 'BASE_TOOLTIP',
  COOKIE_BANNER: 'COOKIE_BANNER',
}
